import React from "react";
import { rhythm } from "../utils/typography";
import styled from "styled-components";
import { Link } from "gatsby";

import ThemeBtn from './ModeBtn';
import { HoverUnderline } from './styleComponents/HoverStyles'

const SVGImg = styled.div`
    width:100%;
    overflow:hidden;
    position:absolute;
    top:0;
    left:0;
    z-index:-10;
`

const NavHeader = styled.header`
    width:100%;
    padding:${rhythm(0.75)} calc((100% - ${rhythm(32)})/2);
    margin-bottom:${rhythm(4)};
    position: relative;
    @media(max-width: 750px) {
        padding:${rhythm(0.75)};
    }
`;


const NavsDiv = styled.div `
    width:100%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    >div{
        display:flex;
        gap:3ch;
    }
    li{
        margin:0;
        font-size:18px;
        font-weight:bolder;
        list-style-type: none;
        font-family:'Roboto';
    }
`;


const NavBar = () => (
    <NavsDiv >
       <div>
       <li>
            <Link to="/">
                <span style={{
                    color: `var(--color-primary)`,
                    fontWeight: '500',
                    // fontSize: "26px",
                    fontFamily: "Signika"
                }}>
                    Jay Gurav
                </span>
            </Link>
        </li>
        <li>
            <Link
                to="/allposts/"
                partiallyActive={true}
                activeStyle={{
                    borderBottom: '2px solid var(--color-secondary)',
                    color: 'var(--color-headingFont)'
                }}
                style={{
                  fontFamily: "Signika",
                  fontWeight: '500',
                }}
            >
                <HoverUnderline>
                    All Posts
                </HoverUnderline>
            </Link>
        </li>
       </div>
       <li><ThemeBtn /></li>
    </NavsDiv>
)


const HeaderDiv = ({ location }) => {
    return (
           <NavHeader>
                <SVGImg>
                    <svg height="100%" width="100%" id="svg" viewBox="0 0 1440 600" xmlns="http://www.w3.org/2000/svg">
                        <path d="M 0,600 C 0,600 0,200 0,200 C 54.61765716248712,179.31776021985573 109.23531432497424,158.63552043971146 191,179 C 272.76468567502576,199.36447956028854 381.6763998625902,260.77567846100993 443,262 C 504.3236001374098,263.22432153899007 518.0590862246651,204.2617657162487 581,202 C 643.9409137753349,199.7382342837513 756.0872552387495,254.17725867399517 833,248 C 909.9127447612505,241.82274132600483 951.5918928203369,175.02919958777053 1012,154 C 1072.4081071796631,132.97080041222947 1151.5451734799037,157.70594297492272 1226,173 C 1300.4548265200963,188.29405702507728 1370.2274132600483,194.14702851253864 1440,200 C 1440,200 1440,600 1440,600 Z" stroke="none" strokeWidth="0" fill="var(--color-foreground)" transform="rotate(-180 720 300)"></path>
                    </svg>
                </SVGImg>
                <NavBar/>
        </NavHeader>
    )
}

export const HeaderDivWithOutSVG  = () => (
    <NavHeader>
        <NavBar/>
    </NavHeader>
)

export default HeaderDiv;